import { render, staticRenderFns } from "./deleteUnselect.vue?vue&type=template&id=1bc137be&"
import script from "./deleteUnselect.vue?vue&type=script&lang=ts&"
export * from "./deleteUnselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports